import { useState } from 'react';
import { Center, Group } from '@mantine/core';
import Icon from '@ui/components/Icon/Icon';
import IconButton from '@ui/components/IconButton/IconButton';
import Text from '@ui/components/Text/Text';
import type Project from 'src/entities/project';
import useCurrentUserProjectPermissions from '@projectMembers/hooks/useCurrentUserProjectPermissions';
import ShareViewOnlyLinkModal from '../../ShareViewOnlyLinkModal/ShareViewOnlyLinkModal';

export type ViewOnlyLinkProps = {
	project: Project;
};

const ViewOnlyLink = ( { project }: ViewOnlyLinkProps ) => {
	const [ linkModalOpened, setLinkModalOpened ] = useState( false );
	const permissions = useCurrentUserProjectPermissions( project.id );
	const currentUserCanShareViewOnlyLink = permissions.currentUserCan( 'shareViewOnlyLink', 'projects' );

	return (
		<>
			<Group position="apart" opacity={currentUserCanShareViewOnlyLink ? 1 : 0.6}>
				<Group spacing={6}>
					<Center bg="var(--color-bg-surface-dim)" p={4} style={{ borderRadius: 4 }}>
						<Icon icon="link" size={14} color="blue.5" />
					</Center>
					<Text variant="footnote-semibold" color="var(--color-text-primary)">Send View-only link</Text>
					<Text variant="footnote" color="var(--color-text-secondary)">Anonymous access</Text>
				</Group>
				<IconButton
					icon="settings_outlined"
					color="var(--color-text-secondary)"
					size={18}
					aria-label="Send view-only link"
					onClick={() => setLinkModalOpened( true )}
					disabled={!currentUserCanShareViewOnlyLink}
				/>
			</Group>
			{linkModalOpened && (
				<ShareViewOnlyLinkModal
					shareable={project}
					onClose={() => setLinkModalOpened( false )}
					stackOrder={2}
				/>
			)}
		</>
	);
};

export default ViewOnlyLink;
